import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap" }
const _hoisted_2 = { style: {"margin-top":"3px"} }
const _hoisted_3 = {
  key: 0,
  class: "row justify-left q-pl-sm full-width"
}
const _hoisted_4 = {
  class: /*@__PURE__*/_normalizeClass(['cursor-pointer', 'text-grey-8' ]),
  style: {"margin-top":"3px"}
}
const _hoisted_5 = { style: {"margin-top":"2px"} }
const _hoisted_6 = {
  class: /*@__PURE__*/_normalizeClass(['q-ml-xs', 'cursor-pointer', 'text-grey-8' ]),
  style: {"margin-top":"3px"}
}
const _hoisted_7 = { style: {"margin-top":"2px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.modelType === 3 && (_ctx.theModel as SelectionProjectStageFilterSend).Positive !== undefined)
        ? (_openBlock(), _createBlock(_component_q_toggle, {
            key: 0,
            modelValue: (_ctx.theModel as SelectionProjectStageFilterSend).Positive,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (((_ctx.theModel as SelectionProjectStageFilterSend).Positive) = $event)),
            class: _normalizeClass(`q-pa-none toggle-checkbox q-mr-none ${_ctx.modelType === 3 ?'unset-items-center' : 'items-center'}`),
            "checked-icon": "add",
            color: "primary",
            label: "",
            size: "xs",
            "unchecked-icon": "remove"
          }, null, 8, ["modelValue", "class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, _toDisplayString((_ctx.theModel as SelectionProjectStageFilterSend).Stage.Name), 1),
      (_ctx.modelType === 3)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            class: "q-px-none q-mx-none unset-items-center",
            style: {"margin-top":"1px","margin-left":"2px"},
            flat: "",
            dense: "",
            "aria-label": _ctx.$t('delete_filter'),
            icon: "close",
            size: "sm",
            tabindex: "-1",
            color: "grey-8",
            onClick: _ctx.emitDelete
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, {
                delay: 300,
                anchor: "top middle",
                self: "center middle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_checkbox, {
        modelValue: (_ctx.theModel as SelectionProjectStageFilterSend).FilterType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((_ctx.theModel as SelectionProjectStageFilterSend).FilterType) = $event)),
        "true-value": 1,
        "false-value": 0,
        "toggle-indeterminate": false,
        "keep-color": false,
        "checked-icon": "event",
        "unchecked-icon": "event",
        size: "sm",
        color: "primary",
        style: {"margin-top":"-5px"},
        class: "q-mx-none q-px-none cursor-pointer"
      }, null, 8, ["modelValue"])
    ]),
    ((_ctx.theModel as SelectionProjectStageFilterSend).FilterType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('after_label')) + "   ", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_VueDatePicker, {
              utc: "preserve",
              timezone: "Europe/Moscow",
              locale: _ctx.$i18n.locale,
              style: _normalizeStyle('width: '+_ctx.fieldWidth+'px; min-width: '+_ctx.fieldWidth+'px; max-width: '+_ctx.fieldWidth+'px;'),
              teleport: true,
              modelValue: (this.theModel as SelectionProjectStageFilterSend).StartDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (((this.theModel as SelectionProjectStageFilterSend).StartDate) = $event)),
              "enable-time-picker": false,
              clearable: false,
              required: true,
              format: _ctx.format,
              "text-input": _ctx.textInputOptions
            }, null, 8, ["locale", "style", "modelValue", "format", "text-input"])
          ]),
          _createElementVNode("div", _hoisted_6, "  " + _toDisplayString(_ctx.$t('to')) + "   ", 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_VueDatePicker, {
              utc: "preserve",
              timezone: "Europe/Moscow",
              locale: _ctx.$i18n.locale,
              style: _normalizeStyle('width: '+_ctx.fieldWidth+'px; min-width: '+_ctx.fieldWidth+'px; max-width: '+_ctx.fieldWidth+'px;'),
              modelValue: (this.theModel as SelectionProjectStageFilterSend).EndDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((this.theModel as SelectionProjectStageFilterSend).EndDate) = $event)),
              teleport: true,
              clearable: false,
              disabled: _ctx.theModel && (_ctx.theModel as SelectionProjectStageFilterSend).EndDateIsToday,
              format: _ctx.format,
              "text-input": _ctx.textInputOptions,
              "enable-time-picker": false
            }, null, 8, ["locale", "style", "modelValue", "disabled", "format", "text-input"])
          ]),
          _createVNode(_component_mosta_checkbox, {
            class: "q-my-none q-py-none q-px-none items-center text-grey-8",
            "onUpdate:modelValue": [
              _ctx.updateCheck,
              _cache[4] || (_cache[4] = ($event: any) => (((_ctx.theModel as SelectionProjectStageFilterSend).EndDateIsToday) = $event))
            ],
            style: {"margin-left":"6px","margin-top":"4px"},
            modelValue: (_ctx.theModel as SelectionProjectStageFilterSend).EndDateIsToday,
            label: _ctx.$t('today_calendar')
          }, null, 8, ["onUpdate:modelValue", "modelValue", "label"])
        ]))
      : _createCommentVNode("", true)
  ]))
}